import React, { useEffect, useState } from 'react'

import { StackType } from 'types/deck'

import { useAppSelector } from 'app-redux/hooks'
import { selectStacks } from 'app-redux/deck/selectors'
import { selectTextColumnWidth } from 'app-redux/cacheables/selectors'

import TextStack from 'components/deckPage/DeckContainerV2/cardGroups/TextStack'
import StickiedDeckControls from 'components/deckPage/filtersAndControls/StickiedDeckControls'

import { getTextColumnCount } from 'components/deckPage/DeckContainerV2/layouts/helperFunctions'

import { useDebouncedResizeObserver } from 'hooks/resizeObservers'

import styles from './text.module.scss'

type Props = {
  stickiedControlsClassName?: string
}

const TextLayout = ({ stickiedControlsClassName }: Props) => {
  const textColumnWidth = useAppSelector(selectTextColumnWidth)
  const { mainDeck, sideDeck } = useAppSelector(selectStacks)

  const { ref, width = 1 } = useDebouncedResizeObserver<HTMLDivElement>(500)

  const [mounted, setMounted] = useState(false)

  const columns = getTextColumnCount(textColumnWidth, width)
  const gridStyles: React.CSSProperties = {
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
    opacity: mounted ? 1 : 0,
  }

  useEffect(() => {
    setTimeout(() => setMounted(true), 500)
  }, [])

  // Used to create the faux masonry layout
  // NOTE - this can be replaced with masonry when it goes mainline
  const displayColumns: StackType[][] = Array.from(Array(columns).keys()).map(() => [])

  for (let i = 0; i < mainDeck.length; i++) {
    const stack = mainDeck[i]
    const allowedColumns = sideDeck.length && columns > 1 ? columns - 1 : columns

    const columnPlacement = i % allowedColumns

    displayColumns[columnPlacement].push(stack)
  }

  if (sideDeck.length) {
    if (columns > 1) displayColumns[columns - 1] = sideDeck
    else displayColumns[0].push(...sideDeck)
  }

  return (
    <div className={styles.container}>
      <StickiedDeckControls className={stickiedControlsClassName} />

      <div className={styles.columns} style={gridStyles} ref={ref}>
        {displayColumns.map((column, columnNumber) => (
          <div
            key={`column-${columnNumber}`}
            className={
              columnNumber === displayColumns.length - 1 && columns > 1 && sideDeck.length
                ? styles.sidedeckColumn
                : undefined
            }>
            {column.map((stack, placeInColumn) => (
              <TextStack
                key={`column-pos-${placeInColumn}`}
                cardIds={stack.cardIds}
                name={stack.name}
                price={stack.price}
                quantity={stack.quantity}
                mdfcQuantity={stack.mdfcQuantity}
                includeInDeck={stack.includedInDeck}
                includeInPrice={stack.includedInPrice}
                isPremier={stack.isPremier}
              />
            ))}

            {!column.length && <div className={styles.emptyColumn}>Empty column</div>}
          </div>
        ))}
      </div>
    </div>
  )
}

export default TextLayout
